import moment from 'moment';
import { isRequired, isEmail } from 'utils/validators';

const validate = values => {
  const errors = {};

  if (!values.dates || !values.dates.startDate || !values.dates.endDate) {
    errors.dates = 'Dates are required';
  } else if (
    moment(values.dates.endDate).diff(values.dates.startDate, 'days') <
    values.minNights
  ) {
    errors.dates = {
      text: 'The number of nights cannot be less than',
      variables: { number: values.minNights }
    };
  }

  if (values.participants && values.participants.length) {
    let participantsArrayErrors = [];
    let isValidParticipants = false;

    values.participants.forEach((item, index) => {
      if (item.participants && parseInt(item.participants) > 0) {
        isValidParticipants = true;
      }

      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (!isValidParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: 'Value for at least one category should be filled in'
      };
    }
  }

  if (
    !errors.participants &&
    values.participants &&
    values.participants.length
  ) {
    const availableParticipants = values.startTime
      ? values.startTime.seatsLeft
      : values.maxParticipants;
    const participantsArrayErrors = [];
    let totalParticipants = 0;

    values.participants.forEach((item, index) => {
      if (item.participants && item.participants.length) {
        totalParticipants += parseInt(item.participants);
      }
      participantsArrayErrors[index] = { participants: 'Error' };
    });

    if (totalParticipants > availableParticipants) {
      errors.participants = {
        ...participantsArrayErrors,
        _error: `The number of Guests can’t exceed ${availableParticipants}`
      };
      errors.isMaxParticipantsErrors = true;
    }
  }

  if (isRequired(values.firstName || '', true)) {
    errors.firstName = 'First name is required';
  }

  if (isRequired(values.lastName || '', true)) {
    errors.lastName = 'Last name is required';
  }

  if (isRequired(values.phone || '', true)) {
    errors.phone = 'Phone is required';
  }

  if (isRequired(values.email || '', true)) {
    errors.email = 'Email is required';
  } else if (isEmail(values.email || '', true)) {
    errors.email = 'Invalid email';
  }

  return errors;
};

export default validate;
